import { Link } from "react-router-dom";
import { FadeUp, MaskedLine } from "@/components/Reveal";

const Treatments = () => {
  return (
    <section
      id="treatments"
      data-chapter="04"
      data-testid="treatments-section"
      className="relative bg-ivory py-20 lg:py-28"
    >
      <div className="mx-auto max-w-[1500px] px-6 lg:px-14">
        <FadeUp className="mb-6 flex items-center gap-5">
          <span className="font-sans text-[11px] font-medium uppercase tracking-[0.4em] text-gold">04 — Treatments</span>
          <span className="h-px w-24 bg-gold/80" />
        </FadeUp>
        <div className="mb-16 flex flex-wrap items-end justify-between gap-8">
          <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-forest sm:text-5xl lg:text-6xl" data-testid="treatments-headline">
            <MaskedLine>Work with intention,</MaskedLine>
            <MaskedLine delay={0.12}>
              <span className="italic text-walnut">not routine.</span>
            </MaskedLine>
          </h2>
          <FadeUp delay={0.2}>
            <p className="max-w-xs font-sans text-sm font-light leading-relaxed tracking-wide text-walnut/80">
              From therapeutic bodywork to restorative skin care, each service
              has a clear purpose.
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.25} className="flex justify-center">
          <Link
            to="/services"
            data-testid="explore-services-link"
            className="group inline-flex items-center gap-5 rounded-full border border-walnut/25 px-10 py-6 font-sans text-sm font-medium uppercase tracking-[0.3em] text-walnut transition-colors duration-500 hover:border-gold hover:bg-sand/30 hover:text-gold sm:px-14 sm:text-base"
          >
            Explore the full services list
            <span className="h-[6px] w-[6px] rounded-full bg-gold transition-transform duration-500 group-hover:scale-150" aria-hidden="true" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
};

export default Treatments;
